var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "Footer" } }, [
    _c("div", { staticClass: "footer_content content_1040" }, [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "company_tel_phone" }, [
            _c("div", { staticClass: "title" }, [_vm._v("客服电话:")]),
            _vm._v(" "),
            _c("div", { staticClass: "bold_text" }, [
              _vm._v(_vm._s(_vm.telNumber))
            ])
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]),
        _vm._v(" "),
        _vm._m(1)
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "copyright" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://beian.miit.gov.cn/#/Integrated/index",
              target: "_blank"
            }
          },
          [_vm._v("© 2019 TMTEXP " + _vm._s(_vm.record))]
        ),
        _vm._v(" "),
        _vm._m(2)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "company_details" }, [
      _c("div", { staticClass: "email" }, [
        _c("div", { staticClass: "title" }, [_vm._v("E-mail:")]),
        _vm._v(" "),
        _c("div", { staticClass: "bold_text" }, [
          _vm._v("support@texperts.com")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "address" }, [
        _c("div", { staticClass: "title" }, [_vm._v("公司地址:")]),
        _vm._v(" "),
        _c("div", { staticClass: "bold_text" }, [
          _vm._v("北京市大兴区广茂大街20号钛媒体创新园")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right" }, [
      _c("div", { staticClass: "item app" }, [
        _c("img", {
          attrs: { src: require("@/assets/logo/app.jpg"), alt: "" }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "title" }, [_vm._v("钛刻专家APP")]),
        _vm._v(" "),
        _c("p", { staticClass: "title" }, [_vm._v("顶尖专家1对1服务")]),
        _vm._v(" "),
        _c("p", { staticClass: "title" }, [_vm._v("扫码下载钛刻专家APP")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-left": "40px" } }, [
      _c(
        "a",
        {
          staticStyle: {
            display: "flex",
            "align-items": "center",
            "justify-content": "center"
          },
          attrs: {
            target: "_blank",
            href:
              "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011502003806"
          }
        },
        [
          _c("img", {
            staticStyle: { width: "20px", height: "20px" },
            attrs: { src: require("./../assets/imgs/bah.png") }
          }),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                height: "20px",
                "font-size": "12px",
                "font-weight": "400",
                color: "rgb(51,51,51)",
                "line-height": "20px",
                margin: "0px 0px 0px 5px"
              }
            },
            [_vm._v("\n            京公网安备 11011502003806号\n          ")]
          )
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ab164b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ab164b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 